// Copyright 2025, University of Maryland, All Rights Reserved
import { useAuth } from '@/subsystems/workspaces';
import { WorkspaceMembersPanel } from '@/subsystems/workspaces/components/workspace-admin/WorkspaceMembersPanel';

export default function WorkspaceAdminPage() {
  const { selectedOrganizationId, selectedWorkspaceId, currentWorkspace } = useAuth();

  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return <div className="p-6 text-center text-muted-foreground">No workspace selected.</div>;
  }

  const workspaceName = currentWorkspace?.name || selectedWorkspaceId;

  return (
    <div className="container mx-auto p-6 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Workspace Admin</h1>
        <p className="text-muted-foreground">{workspaceName}</p>
      </div>
      <WorkspaceMembersPanel orgId={selectedOrganizationId} wsId={selectedWorkspaceId} />
    </div>
  );
}
